import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import { getSelectedClientId } from '../../../../../data/lyraTherapy/clientSelectors'
import { useGetPatientUpcomingAppointmentsQuery } from '../appointmentsApi'

const MAX_UPCOMING_APPOINTMENTS = 3

export const usePatientUpcomingAppointments = (enabled = true) => {
  const patientId = useSelector(getSelectedClientId)
  const result = useGetPatientUpcomingAppointmentsQuery(enabled && patientId ? { patientId } : skipToken)
  return {
    appointments: (result.data ?? []).slice(0, MAX_UPCOMING_APPOINTMENTS),
    isLoading: result.isLoading,
  }
}
